/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Collection_3Inputs */

const en_flow_collection_3 = /** @type {(inputs: Flow_Collection_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Through TIL it reaches Joor, where buyers order it.`)
};

/**
* | output |
* | --- |
* | "Through TIL it reaches Joor, where buyers order it." |
*
* @param {Flow_Collection_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_collection_3 = /** @type {((inputs?: Flow_Collection_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Collection_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_collection_3(inputs)
});